export default "__VITE_ASSET__B3Cx_3cy__"